var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39999 15.8C4.78949 15.2807 4.99999 14.6491 4.99999 14V9.00004C4.99999 5.06244 8.25109 1.88424 12.2154 2.00324C16.0465 2.11824 19 5.46064 19 9.29354V14C19 14.6491 19.2105 15.2807 19.6 15.8C20.5889 17.1185 19.6481 19 18 19H5.99999C4.35189 19 3.41109 17.1185 4.39999 15.8ZM12 22C13.1076 22 14.0642 21.3929 14.5839 20.5H9.41609C9.93579 21.3929 10.8924 22 12 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.00004C21 6.65689 19.6568 8.00004 18 8.00004C16.3431 8.00004 15 6.65689 15 5.00004C15 3.34318 16.3431 2.00004 18 2.00004C19.6568 2.00004 21 3.34318 21 5.00004Z",
    fill: "#00E7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bell-notification.3a0ffce7242ee6c9dae51ad828c209d6.svg";
export { ForwardRef as ReactComponent };